// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { sendEmail } from "@steiner/App/Services/OpenBackOrders";
import { SendEmailWithSheetApiParameter } from "@steiner/App/Services/PipeAndWireSheetPricingServices";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        email?: string;
        message?: string;
    } & HasOnSuccess &
        HasOnError,
    SendEmailWithSheetApiParameter,
    ServiceResult<void>
>;

export const DispatchSetLoading: HandlerType = props => {
    props.dispatch({
        type: "xOpenBackOrders/SetLoading",
        isLoading: true,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        email: props.parameter.email,
        message: props.parameter.message,
    };
};

export const CallSendEmailWithSheet: HandlerType = async props => {
    props.apiResult = {} as ServiceResult<void>;
    try {
        props.apiResult = await sendEmail(props.apiParameter);
        props.apiResult.successful = true;
    } catch (error) {
        props.apiResult.successful = false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const DispatchRemoveLoading: HandlerType = props => {
    props.dispatch({
        type: "xOpenBackOrders/SetLoading",
        isLoading: false,
    } as any);
};

export const chain = [
    DispatchSetLoading,
    PopulateApiParameter,
    CallSendEmailWithSheet,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchRemoveLoading,
];

const sendOpenBackOrdersByEmail = createHandlerChainRunner(chain, "SendOpenBackOrdersByEmail");
export default sendOpenBackOrdersByEmail;
